'use client';

import { revalidatePage } from '@/actions/server.actions';
import FollowNonProfitButton from '@/components/Buttons/FollowNonProfitButton';
import useHasUserSession from '@/hooks/useHasUserSession';
import PostMessage from '@components/PostMessage';
import ShareButton from '@components/ShareButton';
import Typography from '@ui/Typography';
import { isEmpty } from 'lodash-es';
import React, { useState } from 'react';
import { AiFillCheckCircle } from 'react-icons/ai';
import { BiWorld } from 'react-icons/bi';
import { IoIosPeople } from 'react-icons/io';
import { MdVpnLock, MdNorthEast } from 'react-icons/md';
import Tooltip from '@ui/Tooltip';
import { Rating } from '@mui/material';
import CommunityReviewsDialog from '@/components/next-page-components/CommunityReviewsDialog/CommunityReviewsDialog';
import { useGetCommunityRating } from '@/actions/nonprofit.actions';
import useNonProfitSignUpPopUpStore from '@/components/store/nonProfitSignUpPopUpSlice';
import Chip from '@ui/Chip';

function ProfileTitle(props) {
  const { nonProfit, slug, addReview } = props;

  const {
    data: nonProfitRating,
    isLoading: isnonProfitRatingLoading,
    refetch: refetchNonProfitRating,
  } = useGetCommunityRating(nonProfit.id);

  const { totalRating = 0, reviewCount = 0 } =
    nonProfitRating || nonProfit.rating || {};

  const [showReviews, setShowReviews] = useState(!!addReview);

  const averageRating =
    reviewCount > 0 ? Math.round((totalRating / reviewCount) * 10) / 10 : 0;
  const npoLocation = [nonProfit.city, nonProfit.state, nonProfit.country]
    .filter((i) => !!i)
    .join(', ');

  const renderNonProfitType = () => {
    if (nonProfit?.isClaimed) {
      if (nonProfit?.company?.visibilityType === 'private') {
        return (
          <>
            <Typography variant="subtitle2" color="textSecondary">
              Gated
            </Typography>
            <MdVpnLock
              size={24}
              className="text-primary"
              title="Users can join a gated community only after admin approval"
            />
          </>
        );
      } else {
        return (
          <>
            <Typography variant="subtitle2" color="textSecondary">
              Open
            </Typography>
            <BiWorld
              size={24}
              className="text-primary"
              title="In an open community, users can join instantly—just sign up and become a member"
            />
          </>
        );
      }
    }
  };

  const handleReviewClick = () => {
    setShowReviews(true);
  };

  const renderReview = () => {
    return (
      <Typography
        variant="subtitle1"
        color="primary"
        className="cursor-pointer hover:underline"
        onClick={handleReviewClick}>
        {reviewCount
          ? `${reviewCount} Neki review${reviewCount !== 1 ? 's' : ''}`
          : ''}
      </Typography>
    );
  };

  return (
    <div>
      <div className="flex w-full flex-nowrap items-center justify-between gap-3 lg:justify-start lg:pr-2">
        <Typography variant="h2" component="h2">
          {nonProfit.name}
          {/* <div className="my-auto ml-2 inline">
            <ShareButton variant="icon" />
          </div> */}
        </Typography>
      </div>
      <div className="my-1 flex flex-row gap-2">
        {averageRating > 0 && (
          <Typography variant="subtitle1" color="textSecondary">
            {averageRating.toFixed(1)}
          </Typography>
        )}

        <div
          onClick={handleReviewClick}
          className="hover:cursor-pointer"
          title="Write a review">
          <Rating
            name="read-only"
            value={averageRating}
            precision={0.1}
            readOnly
            // className="text-[#D9D9D9]"
            className="text-primary"
          />
        </div>

        {renderReview()}
        {showReviews && (
          <CommunityReviewsDialog
            slug={slug}
            nonProfit={nonProfit}
            onClose={() => setShowReviews(false)}
            refetchNonProfitRating={refetchNonProfitRating}
            communityRating={nonProfitRating || nonProfit.rating}
          />
        )}
      </div>
      <Typography variant="subtitle2" color="textSecondary">
        {npoLocation}
      </Typography>

      {/* {nonProfit?.isClaimed ? (
        <div className="my-1 flex flex-row items-center gap-2">
          <Typography variant="subtitle2" color="textSecondary">
            Claimed
          </Typography>
          <AiFillCheckCircle size={26} className="text-primary" />
        </div>
      ) : (
        <div className="my-1 flex flex-row items-center gap-2 ">
          <Typography
            variant="hyperlink"
            component="a"
            target="_blank"
            className="hover:underline"
            href={nonProfitClaimUrl}>
            Claim this Nonprofit
          </Typography>
          <MdNorthEast
            size={24}
            className="rounded-full bg-primary text-white"
          />
        </div>
      )} */}

      <div className="my-1 flex flex-row items-center gap-2">
        {/* <IoIosPeople size={24} className="text-primary" /> */}
        {/* {renderNonProfitType()} */}
        {/* {hasUserSession ||
          (nonProfit?.numFollowers > 0 && (
            <Typography variant="subtitle2" color="textSecondary">
              {'|'}
            </Typography>
          ))} */}

        {/* {nonProfit?.isClaimed &&
          (nonProfit?.numFollowers > 0 || hasUserSession) && (
            <Typography variant="subtitle2" color="textSecondary">
              {'|'}
            </Typography>
          )} */}

        {nonProfit?.numFollowers > 0 && (
          <Typography variant="subtitle2" color="textSecondary">
            {nonProfit.numFollowers} follower
            {nonProfit?.numFollowers > 1 ? 's' : ''}
          </Typography>
        )}

        {/* {hasUserSession && (
          <FollowNonProfitButton
            size="sm"
            nonProfit={nonProfit}
            noConfirmation
            revalidate={() => revalidatePage('/nonprofit')}
          />
        )} */}
      </div>

      {/* <PostMessage message={nonProfit.description}></PostMessage> */}
      {/* <Typography variant="subtitle2" color="textPrimary"> */}
      <div className="inline-block w-fit">
        <PostMessage
          message={nonProfit.description}
          lineClamp={1}
          // lineHeight={16}
        />
      </div>
      {/* </Typography> */}
      {/* {nonProfit?.donation_url &&
        nonProfit.donation_url.length && (
            <div className="flex gap-2">
              <Typography
                variant="hyperlink"
                component="a"
                target="_blank"
                href={nonProfit?.donation_url}>
                {nonProfit?.donation_url.length > 30
                  ? `${nonProfit?.donation_url.substring(0, 30)}...`
                  : nonProfit?.donation_url}
              </Typography>
              <img
                src="/assets/icons/donate.svg"
                alt="donation_url_logo"
                height="24px"
                width="24px"
                className="object-contain"
              />
            </div>,
          )} */}
      {nonProfit.giving_fund_status === 'ON_HOLD' && (
        <Typography variant="subtitle2" className="text-red-600">
          This organization is currently not in compliance with California
          regulations - please check back later for updates on their status.
        </Typography>
      )}
      {nonProfit.website_url && (
        <div className="flex items-center gap-2">
          <Typography
            variant="hyperlink"
            component="a"
            target="_blank"
            className="hover:underline"
            href={nonProfit.website_url}>
            {/* {nonProfit.website_url.length > 30
              ? `${nonProfit.website_url.substring(0, 30)}...`
              : nonProfit.website_url} */}
            {nonProfit.website_url}
          </Typography>
          {/* <Typography
            variant="hyperlink"
            component="a"
            target="_blank"
            className="hover:underline"
            href={nonProfit.website_url}>
            <img
              src="/assets/icons/weblink.svg"
              alt="website_url"
              height="22px"
              width="22px"
              className="object-contain"
            />
          </Typography> */}
          {/* <a href={nonProfit.website_url}>
            <img
              src="/assets/icons/weblink.svg"
              alt="website_url"
              height="22px"
              width="22px"
              className="object-contain"
            />
          </a> */}
        </div>
      )}

      {!isEmpty(nonProfit.ein) && (
        <div className="my-1 flex items-center gap-2">
          <Typography variant="subtitle2" color="textSecondary">
            {nonProfit.country === 'IN' ? 'Pan #:' : 'EIN:'}
          </Typography>
          <Typography variant="subtitle2" color="textSecondary">
            {nonProfit.ein}
          </Typography>
        </div>
      )}

      {!isEmpty(nonProfit.certifications) && (
        <div className="my-2 flex flex-wrap items-center gap-2">
          {nonProfit.certifications?.map((c) => (
            <div className="">
              {c.description?.length ? (
                <Chip
                  key={c.name}
                  color="secondary"
                  text="small"
                  title={c.description}>
                  {c.name}
                </Chip>
              ) : (
                <Chip key={c.name} color="secondary" text="small">
                  {c.name}
                </Chip>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ProfileTitle;
